import { upgradeAdapter } from '../../upgrade_adapter';
import { Global } from './global.ts';

module.exports = function (ngModule) {
    // load global services
    ngModule.factory('Global', Global);
    // load intercepter
    ngModule.factory('httpInterceptor', require('./interceptor'));
    ngModule.factory('socketIo', require('./socket'));
    ngModule.config(require('./httpprovider'))

    // upgrade services
    upgradeAdapter.upgradeNg1Provider('Global')
    // temp upgrade for angular 2
    upgradeAdapter.upgradeNg1Provider('$location')
}




/** WEBPACK FOOTER **
 ** ./src/system/services/index.ts
 **/